module.exports = __webpack_public_path__ + "92d16e458625f4d2c8940f6bdca0ff09.woff2";